import { connect } from 'react-redux';
import ESS from './ESS';

import {
    setESSkW,
    setESSkWh,
    setESSPrice,
    setMadeInCA,
    setIncludeESS,
    setBatteryType,
} from '../../common/ess/actions';

import { setESSIsVisible } from './actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.essUI.isVisible,
    esskW: state.ess.esskW,
    essPrice: state.ess.essPrice,
    esskWh: state.ess.esskWh,
    madeInCA: state.ess.madeInCA,
    includeESS: state.ess.includeESS,
    projectState: state.projectaddress.projectState,
    batteryType: state.ess.batteryType,
    setIncludeESS,
    setMadeInCA,
    setESSIsVisible,
    setESSkW,
    setESSkWh,
    setESSPrice,
    setBatteryType,
});

const combinedActions = {
    setESSIsVisible,
    setESSkW,
    setESSkWh,
    setESSPrice,
    setMadeInCA,
    setIncludeESS,
    setBatteryType,
};

export default connect(mapStateToProps, combinedActions)(ESS);



// WEBPACK FOOTER //
// ./src/containers/Inputs/ESS/index.js